<template>
  <div>
    <h1>Detalhes do pedido</h1>
    <b-overlay :show="loading" variant="white" blur="2rem" rounded="sm">
      <Form />
    </b-overlay>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapActions } from "vuex";

export default {
  components: { Form },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions("pedidos", [
      "ActionShow",
      "ActionShowPayment",
      "ActionShowPaymentsHistory",
      "ActionResetPedido",
      "ActionResetPagamento",
      "ActionResetPagamentosHistorico",
    ]),
    async loadData(id) {
      try {
        this.loading = true;
        await Promise.all([
          this.ActionShow(id),
          this.ActionShowPayment(id),
          this.ActionShowPaymentsHistory(id),
        ]);
      } catch (error) {
        this.$notifications.addNotification({
          message:
            error.data?.responseMessage ||
            "Não foi possível carregar o pedido.",
          icon: "exclamation-triangle",
          type: "danger",
        });
        this.$router.push({ name: "pedidos_list" });
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    this.ActionResetPedido();
    this.ActionResetPagamento();
    this.ActionResetPagamentosHistorico();
    await this.loadData(this.$route.params.id);
  },
};
</script>

<style></style>
